window.env = {
  "segment": {
    "caQa": "gwDUZjH0hfzEigPZfla0gwkchCNuFJ0i",
    "caProd": "OunvEMDpwsluPWiATkEKJWTAUNBhaYXI",
    "usQa": "SNrD82oQ6Wk3S9jJpRAVI7bdRsLrHzkt",
    "usProd": "2ymbWGIqwjwvaW7FYziyGVAdgN9nhmnW"
  },
  "verbose": false,
  "environment": "prod",
  "knixdigital_key": "XF3DAjlEqsasQDQiiw2377DWufRGwNjz5jXdEwLh",
  "klaviyo_ca": "D4phSK",
  "klaviyo_us": "CYZZ5N",
  "klaviyo_newsletter_id_ca": "NCigkF",
  "klaviyo_newsletter_id_us": "NsFKCY",
  "staging_klaviyo_ca": "T4jVaP",
  "staging_klaviyo_newsletter_id_ca": "WySYA8",
  "amplitude_replay": "eaa2e2c646c7f3d65993525e05868b66",
  "region": "us"
};
